import { EventSpeaker } from "./eventMockData";

/**
 * Claude Design (13) Main Keynote Speaker column. Speakers saved (or kept in a
 * working draft) before the column have no flag, and the website shows the
 * first one as keynote. With no checked speaker, a first speaker without a flag
 * stays the keynote, so loading and saving an older event keeps its page.
 * New speakers are added with false, so the design rule applies to them.
 */
export const resolveEventSpeakerKeynotes = (
  speakers: readonly EventSpeaker[]
): EventSpeaker[] => {
  const hasCheckedSpeaker = speakers.some((speaker) => speaker.isKeynote === true);
  return speakers.map((speaker, index) => ({
    ...speaker,
    isKeynote:
      speaker.isKeynote === true ||
      (!hasCheckedSpeaker && index === 0 && speaker.isKeynote == null),
  }));
};

/** Only one Main Keynote Speaker: checking one clears the others. */
export const setEventSpeakerKeynote = (
  speakers: readonly EventSpeaker[],
  speakerId: string,
  checked: boolean
): EventSpeaker[] =>
  speakers.map((speaker) => ({
    ...speaker,
    isKeynote: checked && speaker.id === speakerId,
  }));
